import React from 'react'
import { Nav } from 'react-bootstrap'
import { Link } from 'raviger'
import classnames from 'classnames'

const SideNavItem = ({ text, icon, url }) => {
  return (
    <Nav.Item className={classnames({ active: window.location.pathname === url })}>
      <Nav.Link href={url} as={Link}>
        {icon}
        <span className="nav-text">{text}</span>
      </Nav.Link>
    </Nav.Item>
  )
}

export default SideNavItem
